import * as React from 'react';

import { PrintPreviewDTO } from 'core/api';

interface Props extends React.HTMLProps<any> {
	preview: PrintPreviewDTO;
}

export default function RdlTemplatePrintPreview(props: Props) {
	const images = props.preview.RdlBase64Images.map((base64Image, i) => <img key={i} className='m-b-xs' src={`data:image/png;base64,${base64Image}`} />);
	return <div className='rdl-print-preview'>{images}</div>;
}
